export const highlightProjects = [
  [
    "Recipe Box",
    "recipe-box.png",
    "https://github.com/rrichy/recipe-box-client",
    "https://recipe-box-by-rrichy.netlify.app/#",
  ],
  [
    "Tic Tac Toe",
    "tic-tac-toe.png",
    "https://github.com/rrichy/tic-tac-toe",
    "https://rrichy.github.io/tic-tac-toe/",
  ],
  [
    "Wiki Viewer",
    "wiki-viewer.png",
    "https://github.com/rrichy/wiki-viewer",
    "https://rrichy.github.io/wiki-viewer/",
  ],
  [
    "Gathering Hall",
    "gathering-hall.png",
    "https://github.com/rrichy/boilerplate-project-secure-real-time-multiplayer-game",
    "https://gathering-hall.herokuapp.com/",
  ],
]; // [Title, imgsrc, srccode, url]

export const normalProjects = [
  [
    "Bar Chart",
    "bar-chart.png",
    "https://github.com/rrichy/fcc-Bar-Chart",
    "https://rrichy.github.io/fcc-Bar-Chart/",
  ],
  [
    "Local Weather",
    "local-weather.png",
    "https://github.com/rrichy/Local-Weather",
    "https://rrichy.github.io/Local-Weather/",
  ],
  [
    "TwitchTV Stream",
    "twitchtv-stream.png",
    "https://github.com/rrichy/twitchtv-stream",
    "https://rrichy.github.io/twitchtv-stream/",
  ],
  [
    "Choropleth Map",
    "choropleth-map.png",
    "https://github.com/rrichy/fcc-D3-Choropleth-Map/",
    "https://rrichy.github.io/fcc-D3-Choropleth-Map/",
  ],
];
